import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-36fcaaee"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "max-w-5xl mx-auto" };
const _hoisted_2 = { class: "flex flex-col my-1" };
const _hoisted_3 = { class: "flex flex-row my-2" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("button", { class: "btn btn-red" }, "新規登録", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Title = _resolveComponent("Title");
    const _component_router_link = _resolveComponent("router-link");
    const _component_Form = _resolveComponent("Form");
    const _component_Table = _resolveComponent("Table");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Title, {
            msg: "テンプレート一覧",
            submsg: "Template List"
        }),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, [
                    _createVNode(_component_router_link, {
                        to: "/template/register",
                        id: "template-register",
                        class: "mr-5"
                    }, {
                        default: _withCtx(() => [
                            _hoisted_4
                        ]),
                        _: 1
                    })
                ])
            ])
        ]),
        _createVNode(_component_Form, {
            searchedDivisions: $data.searchedDivisions,
            templateTitleList: $data.templateTitleList,
            handleSearch: $options.search,
            templateFilter: $options.templateFilter
        }, null, 8, ["searchedDivisions", "templateTitleList", "handleSearch", "templateFilter"]),
        _createVNode(_component_Table, {
            searchedTemplates: $data.searchedTemplates,
            deleteTemplate: $options.remove,
            getTemplate: $options.getBody
        }, null, 8, ["searchedTemplates", "deleteTemplate", "getTemplate"])
    ]));
}
